import {isString, isEmpty} from 'lodash';

const EMPTY_LAYER = 'EMPTY_LAYER';

export default function getLayerIdsFromTiers(tiers, layerGetter) {
    const layerIds = [];
    tiers.forEach(tier => {
        const tierStyle = tier.getStyle();
        if (tierStyle && !isString(tierStyle)) {
            const layer = layerGetter(tierStyle.layers);

            layerIds.push(!isEmpty(layer) ? layer.id : EMPTY_LAYER);
        } else {
            layerIds.push(EMPTY_LAYER);
        }
    });
    return layerIds;
}



// WEBPACK FOOTER //
// ./map/tier/styleUpdate/getLayerIdsFromTiers.js